import {Component, Input, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {
  BokkzAlgDataService,
  BokkzJrDataService, EigenVermogenNatuurlijkPersoon, Jaarrapportage, JaarrapportageEntity, ZakelijkePartner,
} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-ondertekening-natuurlijke-personen',
  templateUrl: './ondertekening-natuurlijke-personen.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule
],
  styleUrls: ['./ondertekening-natuurlijke-personen.component.css']
})
export class OndertekeningNatuurlijkePersonenComponent implements OnInit {

  @Input() public id!: string;
  public jrEntity = {} as JaarrapportageEntity;
  public zakelijkePartnersFg = {} as FormGroup;
  public focusedElementId: string | null = null;
  public index = 0;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public optionsVerantwoordelijkeType: SelectFormControlItem<string>[] = [
    {value: "VERANTWOORDELIJKE", label: "Verantwoordelijke"},
    {value: "GEVOLMACHTIGDE", label: "Gevolmachtigde"},
  ];

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService,
    private fb: FormBuilder) {
    this.zakelijkePartnersFg = this.fb.group({
      zakelijkePartners: this.fb.array<ZakelijkePartner>([]),
    })
  }

  get zakelijkePartners(): FormArray {
    return this.zakelijkePartnersFg.get('zakelijkePartners') as FormArray;
  }

  ngOnInit(): void {
    this.jrDataService.jaarrapportageEntity.subscribe((value) => {
      this.jrEntity = value;
      const item = value.rapportage?.zakelijkePartners;
      if (item) {
        this.updateForm();
      }
    })
  }

  trackByFn(index: number): any {
    return index;
  }

  private createFormGroupZakelijkePartnerEnDisplayName(zakelijkePartner: ZakelijkePartner, indexZakelijkePartner: number): FormGroup {

    const fgZakelijkePartnerEnDisplayName = this.jrDataService.createFormGroupZakelijkePartner(zakelijkePartner);

    const fgDisplayName = this.fb.group({
      value: this.jrDataService.getDisplayNameZakelijkPartner(zakelijkePartner, indexZakelijkePartner) || null as unknown as string,
    });

    fgZakelijkePartnerEnDisplayName.addControl('displayName', fgDisplayName);

    return fgZakelijkePartnerEnDisplayName;
  }

  private updateForm(): void {
    const lijst = this.jrEntity.rapportage?.zakelijkePartners || [];
    const formArray = this.zakelijkePartnersFg.get('zakelijkePartners') as FormArray;
    const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;
    while (formArray.length > lijst.length) {
      formArray.removeAt(formArray.length - 1);
    }

    for (let i = 0; i < lijst.length; i++) {
      if (i < formArray.length) {
        const control = formArray.at(i) as FormGroup;
        control.patchValue(lijst[i]);
      } else {
        const formGroup = this.createFormGroupZakelijkePartnerEnDisplayName(lijst[i], i)
        formArray.push(formGroup);
      }
    }
    if (focusedControl && document.contains(focusedControl)) {
      focusedControl.focus();
    }
  }

  public saveForm(): void {
    this.zakelijkePartnersFg.updateValueAndValidity();
    setTimeout(()=> {
      this.jrEntity = {
        ...this.jrEntity,
        rapportage: {
          ...this.jrEntity.rapportage,
          zakelijkePartners: this.zakelijkePartnersFg.getRawValue().zakelijkePartners,
        }
      } as Jaarrapportage
      this.jrDataService.updateEntity(this.jrEntity);
    },0)
  }
}
